import { useEffect, useState } from "react";
import { getSession, type SessionState, type SessionUser } from "../api/session";

export interface UseSessionResult {
  user: SessionUser | null;
  loading: boolean;
  refresh: () => Promise<void>;
}

export function useSession(): UseSessionResult {
  const [state, setState] = useState<SessionState>({ user: null });
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const s = await getSession();
      setState(s);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void refresh();
  }, []);

  return { user: state.user, loading, refresh };
}
